import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import size from 'lodash/size';
import qs from 'query-string';

// Actions
import * as checklistV2Actions from '../../../../../actions/ChecklistV2Actions';
import { fetchWedding } from '../../../../../actions/WeddingActions';

import PrintChecklistContainer from './PrintChecklistContainer';

const mapDispatchToProps = (dispatch, ownProps) => ({
  init: () => {
    const { location } = ownProps;
    let { q: filters } = qs.parse(location.search);

    if (size(filters)) {
      filters = filters.split(',');
      dispatch(checklistV2Actions.replaceTaskFilters(filters));

      return dispatch(checklistV2Actions.filterTasks());
    }
    return dispatch(checklistV2Actions.fetchChecklist()).then(() => dispatch(fetchWedding()));
  },
});

export default withRouter(connect(null, mapDispatchToProps)(PrintChecklistContainer));



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/PrintChecklist/PrintChecklistContainer/index.js